// extracted by mini-css-extract-plugin
export default {"chips":"styles__chips--FgUca","dashed-chip":"styles__dashed-chip--gaWsB"};